import { isOfMetaOrigin } from "../../marketing-url-params";
import { createTrackingUtils } from "../index";
import { CFAR_FULL_ON_COUNTRIES } from "@flights/ancillaries-universal";

const utils = createTrackingUtils({
  name: "flights_apex_web_cfar_on_sr_fd_v2",
  stages: {
    affected_users: 1,
    main: 2,
    ddot: 3,
    mdot: 4,
    main_sr: 5,
    badge_multiline: 6,
    fd_imbalanced: 7,
    cfar_only: 8,
    sr_less_2: 9
  },
  goals: {
    action_click_with_cfar_badge_on_sr: 1
  },
  defaultStage: 1
});

const trackSearchResultsStages = (
  isMobile: boolean,
  isCfarBadgeMultiline: boolean,
  cfarOnly: boolean,
  shouldTrackSrLess2?: boolean
) => {
  utils.stages.main();
  utils.stages.main_sr();
  if (isMobile) utils.stages.mdot();
  if (!isMobile) utils.stages.ddot();
  if (isCfarBadgeMultiline) utils.stages.badge_multiline();
  if (cfarOnly) utils.stages.cfar_only();
  if (shouldTrackSrLess2) utils.stages.sr_less_2();
};

const trackFlightDetailsStages = (isMobile: boolean) => {
  utils.stages.fd_imbalanced();
  if (!isOfMetaOrigin()) return;
  utils.stages.main();
  if (isMobile) utils.stages.mdot();
  if (!isMobile) utils.stages.ddot();
};

const isEligablePos = (pointOfSale: string | undefined) =>
  CFAR_FULL_ON_COUNTRIES.includes((pointOfSale || "").toLowerCase());

export default { ...utils, trackSearchResultsStages, trackFlightDetailsStages, isEligablePos };
